import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import {Row, Col} from 'react-flexbox-grid'
import {SlideDown} from 'react-slidedown'
import config from '../../config'
import format from '../../helpers/format'
import {
  Link,
  LinkIcon,
  XsBr,
} from '../../components'
import Styles from './PlanScorecardIssueAllocations.css'


@CSSModules(Styles,{allowMultiple:true})
class PlanScorecardIssueAllocationsTableHead extends Component {
  static propTypes = {
    headLabel: PropTypes.string,
  }
  constructor(props){
    super(props)
  }
  render() {
    const { headLabel } = this.props
    //
    return (
      <thead>
        <tr>
          <th colSpan='5'>
            <div styleName='th main-table-heading'>
              <b>{headLabel}</b> <XsBr/>scorecard
            </div>
          </th>
        </tr>
        <tr>
          <th/>
          <th>Target date funds</th>
          <th>Equity funds</th>
          <th>Total flagged</th>
          <th>% of plan assets</th>
        </tr>
      </thead>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
class PlanScorecardIssueAllocationsTableRow extends Component {
  static propTypes = {
    iyvCode: PropTypes.string,
    shrtLbl: PropTypes.string,
    lngLbl: PropTypes.string,
    screenResults: PropTypes.object,
  }
  constructor(props){
    super(props)
  }
  render() {
    const { iyvCode, shrtLbl, lngLbl, screenResults } = this.props
    const icon = require( `../../../static/images/icons/${iyvCode}-icon.svg` )
    //
    return (
      <tr>
        <td>
          <div styleName='alloc-icn-lbl'>
            <div styleName='result-lbl-icon-bbl'>
              <img
                styleName='result-lbl-icon'
                src={icon}
                alt={shrtLbl}
              />
            </div>
            <div styleName='alloc-icn-lbl-txt'>
              {lngLbl}
            </div>
          </div>
        </td>
        <td>{screenResults[iyvCode].td}</td>
        <td>{screenResults[iyvCode].eq}</td>
        <td>{screenResults[iyvCode].tot}</td>
        <td>{screenResults[iyvCode].perc}</td>
      </tr>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
class PlanScorecardIssueAllocationsNoData extends Component {
  render() {
    return (
      <div styleName='plan-option-card'>
        <h3 styleName='allocation-subtitle'>
          This plan is missing allocation data.
        </h3>
        <p>
          We have data on the fund
          options offered to plan participants, but no data on how much is
          invested in each fund option, or the overall amount invested in
          risk categories like fossil fuels, deforestation-risk agribusiness,
          or arms manufacturers.
          This can happen when a plan updates their investment options, but a
          new <Link
            to={config.routes.faqs + '#where-does-the-data-for-my-retirement-plan-scorecard-come-from-'}
            xstrong
            title='Where does the data for my retirement plan scorecard come from?'
          >Form 5500</Link> has not yet been filed.
          Check back soon to see if allocation data for this fund has been
          added.
        </p>
      </div>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
export default class PlanScorecardIssueAllocations extends Component {
  static propTypes = {
    planData: PropTypes.object
  }
  constructor(props){
    super(props)
    this.state = {
      showFullAllocationTable: false
    }
  }

  //
  render() {
    if (!this.props.planData) { return null }
    const { planData } = this.props

    // if no allocation data for plan
    if (planData.allocations.default === 0) {
      return <PlanScorecardIssueAllocationsNoData />
    }

    // chart image
    let hasAllocationChartImg = false
    let allocationChartUrl = null
    let allocationChartImg = null
    try {
      allocationChartImg = require(
        '../../../static/images/charts/' + planData.path + '_' +
          planData.year + '_chart.png'
      )
      allocationChartUrl = config.domain + '/images/charts/' + planData.path +
        '_' + planData.year + '_chart.png'
      hasAllocationChartImg = true
    }
    catch (e) {
      console.log('')
    }

    // map results from planData to a screenResults object
    const lbls = ['fff','dff','gff','pff','wff','tff']
    const screenResults = {}
    for (let i = 0; i < lbls.length; i++) {
      const lbl = lbls[i]
      screenResults[lbl] = {
        eq: format.money(
          planData.screen_results[lbl][0], true, 'USD', true, 0
        ),
        td: format.money(
          planData.screen_results[lbl][1], true, 'USD', true, 0
        ),
        tot: format.money(
          planData.screen_results[lbl][0] +
            planData.screen_results[lbl][1],
          true,
          'USD',
          true,
          0
        ),
        perc: format.perc(
          (planData.screen_results[lbl][0] +
            planData.screen_results[lbl][1]) /
            planData.plan_assets
        )
      }
    }

    const environmentConfig = [
      [
        'fff',
        'Fossil fuels',
        'Fossil fuels'
      ],
      [
        'dff',
        'Deforestation',
        'Deforestation-risk agribusiness commodity producer/traders'
      ]
    ]

    const socialConfig = [
      [
        'gff',
        'Civilian firearms',
        'Civilian firearms manufacturers'
      ],
      [
        'pff',
        'Prison industrial complex',
        'Prison industrial complex, high risk'
      ],
      [
        'wff',
        'Military weapons',
        'Arms manufacturers and military contractors'
      ],
      [
        'tff',
        'Tobacco',
        'Tobacco producer/manufacturers'
      ],
    ]

    //
    return(
      <div>
        <div styleName='plan-option-card'>
          <h2 styleName='allocation-subtitle'>
            This retirement plan has millions of dollars invested in
            fossil fuels, deforestation-risk agribusiness, and arms
            manufacturers.
          </h2>
          { hasAllocationChartImg ?
              <div>
                <Link
                  to={allocationChartUrl}
                  title={
                    planData.primary_plan_name+' flagged investments'
                  }
                  targetBlank
                >
                  <img
                    src={allocationChartImg}
                    alt={
                      planData.primary_plan_name+' flagged investments'
                    }
                    styleName='allocation-chart-img'
                  />
                  <span styleName='allocation-chart-expand-label visible-xs'>
                    Click to enlarge<LinkIcon faclass='fa-expand'/>
                  </span>
                </Link>
                <div styleName='allocation-sublede'>
                  The figures in this chart and the tables below are
                  calculated by cross-referencing annual data on  plan
                  investments for {planData.year} (using Form 5500 data
                  filed {planData.filing_received}) and monthly data on
                  mutual fund holdings from {config.versionDate}.

                  The results
                  represent a best-faith effort to measure plan participant
                  exposure to various environmental and social risk screens
                  using the most recent data available.

                  The actual amount
                  invested by the plan may be higher today as employees have
                  made further contributions since {planData.year}.

                  These results represent stock investments within the
                  plan's target date and equity funds, and do not capture
                  any risky investments in other fund types or through
                  a self-directed option.

                  The results also do not include any risky investments in
                  target date options or equity fund options
                  if those options are
                  closed-end funds where we lack access to holdings, or
                  collective trusts that we were unable to match to a
                  suitable mutual fund as a stand-in. For more
                  information, <Link
                    to={config.routes.methodology}
                    title='Methodology'
                    xstrong
                  >read our full methodology here.</Link>
                </div>
              </div> :
              null
          }
        </div>
        <br/>
        <br/>
        <button
          styleName='section-slidedown-button'
          onClick={
            (e)=>{
              this.setState({
                showFullAllocationTable: !this.state.showFullAllocationTable
              })
            }
          }
        >
          <div styleName='section-slidedown-label'>
            Allocation details
          </div>
          <div styleName='section-slidedown-icon'>
            <LinkIcon
              faclass={
                this.state.showFullAllocationTable ?
                  'fa-angle-up' :
                  'fa-angle-down'
              }
            />
          </div>
        </button>
        <SlideDown>
          { this.state.showFullAllocationTable ?
              <div>
                {  this.props.planData.path === 'thrift_savings_plan' ?
                    <div styleName='tsp-disclaimer'>
                      <div styleName='tsp-disclaimer-icon'>
                        <LinkIcon nospace faclass='fa-info-circle' />
                      </div>
                      <p>
                        Like most retirement plans, The Thrift Savings Plan is
                        composed of target date funds, as well as individual
                        equity and bond funds.
                        But the Thrift Savings Plan is unique in that the
                        target date L Funds are themselves composed of the
                        individual C, S, I, F, and G funds.
                        The figures below for the
                        equity funds (the C, S, and I funds)
                        have been adjusted to account for this, to avoid
                        double counting.
                        Any assets in the C, S, and I funds that are held
                        via target date L funds are allocated to the target
                        date lineup.
                      </p>
                    </div> :
                    null
                }
                <div styleName='screen-results-table-wrap'>
                  <table styleName='full-row-table'>
                    <PlanScorecardIssueAllocationsTableHead
                      headLabel='Environment'
                    />
                    <tbody>
                      {
                        environmentConfig.map((e, i) => {
                          return (
                            <PlanScorecardIssueAllocationsTableRow
                              key={'tr-e-'+i}
                              iyvCode={e[0]}
                              shrtLbl={e[1]}
                              lngLbl={e[2]}
                              screenResults={screenResults}
                            />
                          )
                        })
                      }
                    </tbody>
                  </table>
                </div>
                <div styleName='screen-results-table-wrap'>
                  <table styleName='full-row-table'>
                    <PlanScorecardIssueAllocationsTableHead
                      headLabel='Social'
                    />
                    <tbody>
                      {
                        socialConfig.map((e, i) => {
                          return (
                            <PlanScorecardIssueAllocationsTableRow
                              key={'tr-s-'+i}
                              iyvCode={e[0]}
                              shrtLbl={e[1]}
                              lngLbl={e[2]}
                              screenResults={screenResults}
                            />
                          )
                        })
                      }
                    </tbody>
                  </table>
                </div>
                <div styleName='screen-results-table-post'>
                  <h2>
                    Total plan assets analyzed: <b>
                      {
                        format.money(
                          planData.plan_assets,
                          true,
                          'USD',
                          true,
                          1
                        )
                      }
                    </b> invested in <b>
                      {planData.plan_option_count}
                    </b> plan options*
                  </h2>
                  <p>
                    *Listed plan assets account only for investment
                    options offered directly by the plan administrator, and don't include
                    any assets invested in self-directed options, or any
                    participant loans.
                  </p>
                </div>
              </div> :
              null
          }
        </SlideDown>
        <br/>
        <br/>
      </div>
    )
  }
}